import { resolveEmendaStatus, type EmendaDTO } from '../services/emendaService';

// Etapas da tramitação da emenda (mesma sequência do stepper da tela de detalhe).
export const ETAPAS = ['Recebido', 'Admissibilidade', 'Demanda', 'Documental', 'Em execução', 'Concluído'] as const;

// statusCicloVida -> índice da etapa. A parte jurídica ocorre no plano de
// trabalho, então status pós-documental/execução caem em "Execução".
const STATUS_TO_ETAPA: Record<string, number> = {
  'Em aprovação': 0,
  'Recebido': 0,
  'Em análise de admissibilidade': 1,
  'Admissibilidade aprovada': 2,
  'Devolvida ao legislativo': 1,
  'Em análise de demanda': 2,
  'Análise de demanda aprovada': 3,
  'Retornada ao Orçamento (demanda)': 2,
  'Devolvida por incompatibilidade de demanda': 2,
  'Em análise documental': 3,
  'Retornada ao Orçamento (documental)': 3,
  'Devolvida por inviabilidade documental': 3,
  'Análise documental aprovada': 4,
  'Iniciado': 4,
  'Em execução': 4,
  'Devolvido': 4,
  'Concluído': 5,
};

// Cor do selo por etapa (devolvida sobrescreve com vermelho).
const ETAPA_BADGE: Record<string, string> = {
  'Em aprovação':    'bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-200',
  'Recebido':        'bg-blue-100 text-blue-800 dark:bg-blue-900/50 dark:text-blue-200',
  'Admissibilidade': 'bg-amber-100 text-amber-800 dark:bg-amber-900/50 dark:text-amber-200',
  'Demanda':         'bg-teal-100 text-teal-800 dark:bg-teal-900/50 dark:text-teal-200',
  'Documental':      'bg-violet-100 text-violet-800 dark:bg-violet-900/50 dark:text-violet-200',
  'Em execução':     'bg-indigo-100 text-indigo-800 dark:bg-indigo-900/50 dark:text-indigo-200',
  'Concluído':       'bg-emerald-100 text-emerald-800 dark:bg-emerald-900/50 dark:text-emerald-200',
};
const ETAPA_BADGE_DEVOLVIDA = 'bg-red-100 text-red-800 dark:bg-red-900/50 dark:text-red-200';

export const etapaBadgeClass = (etapa: { label: string; devolvida: boolean }): string =>
  etapa.devolvida ? ETAPA_BADGE_DEVOLVIDA : (ETAPA_BADGE[etapa.label] ?? ETAPA_BADGE['Recebido']);

export interface EtapaInfo {
  index: number;
  label: string;
  devolvida: boolean;
}

export const emendaEtapa = (emenda?: Pick<EmendaDTO, 'status' | 'statusCicloVida' | 'tipoTransferencia'> | null): EtapaInfo => {
  const status = resolveEmendaStatus(emenda);
  const isDireta = emenda?.tipoTransferencia !== 'Indireta';
  // Direta pula o Documental: demanda aprovada vai direto para Execução.
  const index = (status === 'Análise de demanda aprovada' && isDireta) ? 4 : (STATUS_TO_ETAPA[status] ?? 0);
  return {
    index,
    // "Em aprovação" ainda está na Câmara: não pode aparecer como "Recebido" (da Prefeitura).
    label: status === 'Em aprovação' ? 'Em aprovação' : (ETAPAS[index] ?? 'Recebido'),
    devolvida: /^devolvid/i.test(status),
  };
};
